import { render, staticRenderFns } from "./scatterChart.vue?vue&type=template&id=2948446e&scoped=true&"
import script from "./scatterChart.vue?vue&type=script&lang=js&"
export * from "./scatterChart.vue?vue&type=script&lang=js&"
import style0 from "./scatterChart.vue?vue&type=style&index=0&id=2948446e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2948446e",
  null
  
)

export default component.exports